import React from "react";
import styled from "styled-components";

const StyledLabel = styled.label`
  display: block;
  font-weight: bold;
  font-size: 1.06em;
  margin-bottom: 0.25em;
  @media (min-width: 768px) {
    font-size: 1em;
  }
`;

function InputLabel({ children, ...rest }) {
  return <StyledLabel {...rest}>{children}</StyledLabel>;
}

export default InputLabel;
